import mergeClasses from '../../../utils/shallowMerge';
import defaultClasses from './SelectList.module.scss';
import { SelectListItem } from './SelectListItem';
import { useSelectContext } from './useSelectContext';
import React from 'react';
import { animated, useSpring } from 'react-spring';

export const SelectList = React.memo((props) => {
  const {
    isExpanded,
    selectedValue,
    fieldRef,
    optionsComputedProps,
    optionsMenuRef,
  } = useSelectContext();

  const children = fieldRef.current && props.children;
  const menuAppear = useSpring({
    transform: isExpanded ? 'translate3D(0,0,0)' : 'translate3D(0,-1px,0)',
    opacity: isExpanded ? 1 : 0,
  });
  const styles = mergeClasses(defaultClasses, props.customClasses);

  const style = {
    position: 'absolute',
    height: '100%',
    width: '100%',
    left: '0',
    right: '0',
    top: optionsComputedProps.top - 1 || '',
    bottom: optionsComputedProps.bottom,
    maxHeight: optionsComputedProps.maxHeight,
  };

  return isExpanded && children ? (
    <animated.div style={{ ...style, ...menuAppear, zIndex: '41' }}>
      <ul
        role="listbox"
        ref={optionsMenuRef}
        className={`${styles.selectList} ${styles.selectListActive} ${
          props.openToTop ? styles.selectListOpenToTop : ''
        }`}
      >
        {Object.values(children).map((item, index) => {
          return item.props?.isHiddenFromDropdown ? null : (
            <SelectListItem
              placeholder={props.isPlaceholder && !index ? true : false}
              isDisabled={item.props?.isDisabled}
              itemIndex={index}
              className={item.props.className}
              item={item}
              isSelected={
                item.props.value && item.props.value === selectedValue
              }
              key={`${item.props.value && item.props.value}_}`}
              isOutOfStock={item.props.isOutOfStock}
            >
              {item.props.isOutOfStock && item.props.isOutOfStock}
              {item.props.htmlContent || item.props.label}
            </SelectListItem>
          );
        })}
      </ul>
    </animated.div>
  ) : null;
});
